<template>
  <div>
    <Homeicon />
    <div class="main">
      <ul class="items">
        <li
          :id="index"
          @touchmove.prevent="dragging(index)"
          @touchstart.prevent="drag(index)"
          @touchend.prevent="drop(index)"
          v-for="(item, index) in shuffle_itemList"
          :key="item.id"
          v-bind:class="['item-' + index]"
        ></li>
      </ul>
    </div>
    <div id="dropzone1"></div>
    <div id="dropzone2"></div>
    <div id="dropzone3"></div>
    <div id="dropzone4"></div>
    <img class="growing-button1" v-show="isPlay1 === true" src="@/assets/img/アセット 9@3x.png" />
    <img class="growing-button2" v-show="isPlay2 === true" src="@/assets/img/アセット 9@3x.png" />
    <img class="growing-button3" v-show="isPlay3 === true" src="@/assets/img/アセット 9@3x.png" />
    <img class="growing-button4" v-show="isPlay4 === true" src="@/assets/img/アセット 9@3x.png" />

    <div class="play-back" @click="musicPlayList">
      <img src="@/assets/img/アセット 63@3x.png" />
    </div>

    <div class="play-btns">
      <ul class="play-btn">
        <li class="play-btn1" v-if="isPlay1 === false">
          <img src="@/assets/img/アセット 65@3x.png" @click="playMusic1" />
        </li>
        <li class="play-btn1" v-else>
          <img src="@/assets/img/アセット 65-2@3x.png" @click="stopMusic1" />
        </li>
        <li class="play-btn2" v-if="isPlay2 === false">
          <img src="@/assets/img/アセット 65@3x.png" @click="playMusic2" />
        </li>
        <li class="play-btn2" v-else>
          <img src="@/assets/img/アセット 65-2@3x.png" @click="stopMusic2" />
        </li>
        <li class="play-btn3" v-if="isPlay3 === false">
          <img src="@/assets/img/アセット 65@3x.png" @click="playMusic3" />
        </li>
        <li class="play-btn3" v-else>
          <img src="@/assets/img/アセット 65-2@3x.png" @click="stopMusic3" />
        </li>
        <li class="play-btn4" v-if="isPlay4 === false">
          <img src="@/assets/img/アセット 65@3x.png" @click="playMusic4" />
        </li>
        <li class="play-btn4" v-else>
          <img src="@/assets/img/アセット 65-2@3x.png" @click="stopMusic4" />
        </li>
      </ul>
    </div>
    <PittanBtn
      ref="child"
      :isActive1="isActive1"
      :isActive2="isActive2"
      :isActive3="isActive3"
      :isActive4="isActive4"
      :judgment1="judgment1"
      :judgment2="judgment2"
      :judgment3="judgment3"
      :judgment4="judgment4"
      :mistakeactive="mistakeactive"
      @eventname1="updateCorrectAnswerFlag1"
      @eventname2="updateCorrectAnswerFlag2"
      @eventname3="updateCorrectAnswerFlag3"
      @eventname4="updateCorrectAnswerFlag4"
      @submission="setActTime"
      @stopmusic="allStopMusic"
    />
  </div>
</template>

<script>
import Homeicon from "@/components/Homeicon";
import PittanBtn from "@/components/PittanBtn";
export default {
  beforeCreate: function () {
    document.body.className = "play";
  },
  components: {
    Homeicon: Homeicon,
    PittanBtn: PittanBtn,
  },
  data() {
    return {
      options: {
        group: "myGroup",
        animaition: 200,
      },
      itemList: [
        {
          id: 1,
          name: "name1",
          soundcellnumber: "1",
          sound: [],
        },
        {
          id: 2,
          name: "name02",
          soundcellnumber: "2",
          sound: [],
        },
        {
          id: 3,
          name: "name03",
          soundcellnumber: "3",
          sound: [],
        },
        {
          id: 4,
          name: "name04",
          soundcellnumber: "4",
          sound: [],
        },
        {
          id: 5,
          name: "name05",
          soundcellnumber: "1+",
          sound: [],
        },
        {
          id: 6,
          name: "name06",
          soundcellnumber: "2+",
          sound: [],
        },
        {
          id: 7,
          name: "name07",
          soundcellnumber: "3+",
          sound: [],
        },
        {
          id: 8,
          name: "name08",
          soundcellnumber: "4+",
          sound: [],
        },
      ],
      shuffle_itemList: [],
      playCount: 0,
      pickedup: false,
      isPlay1: false,
      isPlay2: false,
      isPlay3: false,
      isPlay4: false,
      isPlayList: false,
      isActive1: null,
      isActive2: null,
      isActive3: null,
      isActive4: null,
      judgment1: null,
      judgment2: null,
      judgment3: null,
      judgment4: null,
      mistakeactive: false,
      parentvariable1: Boolean,
      parentvariable2: Boolean,
      parentvariable3: Boolean,
      parentvariable4: Boolean,
      animationId: 0,
      minutes: 0,
      second: 0,
      milisecond: 0,
      startTime: 0, // スタート時間
      endTime: 0, // ストップ押した時間
      diffTime: 0, //スタートとストップ押した時の差分
      flag: false,
      act_number: 0,
      p1_block_number: "",
      p2_block_number: "",
      p3_block_number: "",
      p4_block_number: "",
      p1_audition_flg: 0,
      p2_audition_flg: 0,
      p3_audition_flg: 0,
      p4_audition_flg: 0,
      play_button_flg: 0,
      stop_flg: 0,
      PlayList: [],
    };
  },
  async mounted() {
    const val = this.$store.state.selectedSong;
    const res = await this.axios
      .get(process.env.API_ENDPOINT + "/songs/" + val, {
        headers: {
          Authorization:
            "Bearer " + this.$cookies.get('token'),
          "Ocp-Apim-Subscription-Key": process.env.SUBSCRIPTION_KEY,
        },
      })
      .then(
        (response) => (
          (this.itemList[0].sound = response.data.sounds.original_1),
          (this.itemList[1].sound = response.data.sounds.original_2),
          (this.itemList[2].sound = response.data.sounds.original_3),
          (this.itemList[3].sound = response.data.sounds.original_4),
          (this.itemList[4].sound = response.data.sounds.variation_1),
          (this.itemList[5].sound = response.data.sounds.variation_2),
          (this.itemList[6].sound = response.data.sounds.variation_3),
          (this.itemList[7].sound = response.data.sounds.variation_4)
        )
      )
      .catch((response) => console.log(response));
    this.shuffle_itemList = this.shuffle(this.itemList);
  },
  filters: {
    zeroPadding(value) {
      return value.toString().padStart(2, 0);
    },
    showMiliseconds(value) {
      return value.toString().padStart(3, 0);
    },
  },
  methods: {
    shuffle: function (array) {
      for (let i = array.length - 1; i > 0; i--) {
        let r = Math.floor(Math.random() * (i + 1));
        let tmp = array[i];
        array[i] = array[r];
        array[r] = tmp;
      }
      return array;
    },
    updateCorrectAnswerFlag1(correctAnswerFlag1) {
      this.parentvariable1 = correctAnswerFlag1;
    },
    updateCorrectAnswerFlag2(correctAnswerFlag2) {
      this.parentvariable2 = correctAnswerFlag2;
    },
    updateCorrectAnswerFlag3(correctAnswerFlag3) {
      this.parentvariable3 = correctAnswerFlag3;
    },
    updateCorrectAnswerFlag4(correctAnswerFlag4) {
      this.parentvariable4 = correctAnswerFlag4;
    },
    drag(index) {
      if (parseInt(event.target.id) === this.isActive1) {
        this.isActive1 = null;
        this.p1_block_number;
      }
      if (parseInt(event.target.id) === this.isActive2) {
        this.isActive2 = null;
        this.p2_block_number;
      }
      if (parseInt(event.target.id) === this.isActive3) {
        this.isActive3 = null;
        this.p3_block_number;
      }
      if (parseInt(event.target.id) === this.isActive4) {
        this.isActive4 = null;
        this.p4_block_number;
      }
      const doc = document.getElementById(index);
      doc.style.zIndex = 99;
      this.pickedup = true;
      this.mistakeactive = false;
    },
    dragging(index) {
      const doc = document.getElementById(index);
      let leftlimit = -10
      //押下中だったら
      if (this.pickedup) {
        doc.style.left = event.changedTouches[0].clientX - 50 + "px";
        doc.style.top = event.changedTouches[0].clientY - 100 + "px";
      }
    },
    drop(index) {
      this.doc = document.getElementById(index);
      this.doc.style.zIndex = 50;
      this.pickedup = false;
      this.x = event.changedTouches[0].clientX;
      this.y = event.changedTouches[0].clientY;
      if (this.isActive1 === null) this.dropzone1(index);
      if (this.isActive2 === null) this.dropzone2(index);
      if (this.isActive3 === null) this.dropzone3(index);
      if (this.isActive4 === null) this.dropzone4(index);
      if (parseInt(event.target.id) !== this.isActive1)
        this.barrier1(index);
      if (parseInt(event.target.id) !== this.isActive2)
        this.barrier2(index);
      if (parseInt(event.target.id) !== this.isActive3)
        this.barrier3(index);
      if (parseInt(event.target.id) !== this.isActive4)
        this.barrier4(index);
    },
    dropzone1(index) {
      const dropzone1 = document.getElementById("dropzone1");
      const clientRect = dropzone1.getBoundingClientRect();
      if (
        this.x >= clientRect.x &&
        this.x <= clientRect.x + clientRect.width &&
        this.y >= clientRect.y &&
        this.y <= clientRect.y + clientRect.height
      ) {
        this.doc.style.top = "484px";
        this.doc.style.left = "241px";
        this.isActive1 = index;
        this.judgment1 = this.itemList[index].id
        this.music1 = this.itemList[index].sound;
        this.p1_block_number = this.itemList[index].soundcellnumber;
      }
    },
    dropzone2(index) {
      const dropzone2 = document.getElementById("dropzone2");
      const clientRect2 = dropzone2.getBoundingClientRect();
      if (
        this.x >= clientRect2.x &&
        this.x <= clientRect2.x + clientRect2.width &&
        this.y >= clientRect2.y &&
        this.y <= clientRect2.y + clientRect2.height
      ) {
        if (!this.isActive2) {
          this.doc.style.top = "484px";
          this.doc.style.left = "389px";
          this.isActive2 = index;
          this.judgment2 = this.itemList[index].id
          this.music2 = this.itemList[index].sound;
          this.p2_block_number = this.itemList[index].soundcellnumber;
        }
      }
    },
    dropzone3(index) {
      const dropzone3 = document.getElementById("dropzone3");
      const clientRect3 = dropzone3.getBoundingClientRect();
      if (
        this.x >= clientRect3.x &&
        this.x <= clientRect3.x + clientRect3.width &&
        this.y >= clientRect3.y &&
        this.y <= clientRect3.y + clientRect3.height
      ) {
        if (!this.isActive3) {
          this.doc.style.top = "484px";
          this.doc.style.left = "535px";
          this.isActive3 = index;
          this.judgment3 = this.itemList[index].id
          this.music3 = this.itemList[index].sound;
          this.p3_block_number = this.itemList[index].soundcellnumber;
        }
      }
    },
    dropzone4(index) {
      const dropzone4 = document.getElementById("dropzone4");
      const clientRect4 = dropzone4.getBoundingClientRect();
      if (
        this.x >= clientRect4.x &&
        this.x <= clientRect4.x + clientRect4.width &&
        this.y >= clientRect4.y &&
        this.y <= clientRect4.y + clientRect4.height
      ) {
        if (!this.isActive4) {
          this.doc.style.top = "484px";
          this.doc.style.left = "681px";
          this.isActive4 = index;
          this.judgment4 = this.itemList[index].id
          this.music4 = this.itemList[index].sound;
          this.p4_block_number = this.itemList[index].soundcellnumber;
        }
      }
    },
    barrier1() {
      if (this.isActive1 !== null) {
        const dropzone1 = document.getElementById("dropzone1");
        const clientRect = dropzone1.getBoundingClientRect();
        if (
          this.x >= clientRect.x &&
          this.x <= clientRect.x + clientRect.width &&
          this.y >= clientRect.y &&
          this.y <= clientRect.y + clientRect.height
        ) {
          this.doc.style.zIndex = 100;
          this.doc.style.top = "484px";
          this.doc.style.left = "260px";
        }
      }
    },
    barrier2() {
      if (this.isActive2 !== null) {
        const dropzone2 = document.getElementById("dropzone2");
        const clientRect = dropzone2.getBoundingClientRect();
        if (
          this.x >= clientRect.x &&
          this.x <= clientRect.x + clientRect.width &&
          this.y >= clientRect.y &&
          this.y <= clientRect.y + clientRect.height
        ) {
          this.doc.style.zIndex = 100;
          this.doc.style.top = "484px";
          this.doc.style.left = "420px";
        }
      }
    },
    barrier3() {
      if (this.isActive3 !== null) {
        const dropzone3 = document.getElementById("dropzone3");
        const clientRect = dropzone3.getBoundingClientRect();
        if (
          this.x >= clientRect.x &&
          this.x <= clientRect.x + clientRect.width &&
          this.y >= clientRect.y &&
          this.y <= clientRect.y + clientRect.height
        ) {
          this.doc.style.zIndex = 100;
          this.doc.style.top = "484px";
          this.doc.style.left = "560px";
        }
      }
    },
    barrier4() {
      if (this.isActive4 !== null) {
        const dropzone4 = document.getElementById("dropzone4");
        const clientRect = dropzone4.getBoundingClientRect();
        if (
          this.x >= clientRect.x &&
          this.x <= clientRect.x + clientRect.width &&
          this.y >= clientRect.y &&
          this.y <= clientRect.y + clientRect.height
        ) {
          this.doc.style.zIndex = 100;
          this.doc.style.top = "484px";
          this.doc.style.left = "710px";
        }
      }
    },
    //第一再生ボタン押下時処理
    playMusic1() {
      if (this.isActive1 !== null) {
        this.commonProcessing()//再生ボタン押下時共通処理
        this.p1_audition_flg = 1;
        const dropzone1 = document.getElementById("dropzone1");
        dropzone1.style.zIndex = 60;
        this.audio1 = new Audio();
        this.audio1.src = this.music1;
        this.audio1.play();
        this.isPlay1 = true;
        let self = this;
        this.audio1.addEventListener(
          "ended",
          function () {
            self.isPlay1 = false;
            dropzone1.style.zIndex = 0;
          },
          false
        );
      }
    },
    //第二再生ボタン押下時処理
    playMusic2() {
      if (this.isActive2 !== null) {
        this.commonProcessing()//再生ボタン押下時共通処理
        this.p2_audition_flg = 1;
        const dropzone2 = document.getElementById("dropzone2");
        dropzone2.style.zIndex = 60;
        this.audio2 = new Audio();
        this.audio2.src = this.music2;
        this.audio2.play();
        this.isPlay2 = true;
        let self = this;
        this.audio2.addEventListener(
          "ended",
          function () {
            self.isPlay2 = false;
            dropzone2.style.zIndex = 0;
          },
          false
        );
      }
    },
    //第三再生ボタン押下時処理
    playMusic3() {
      if (this.isActive3 !== null) {
        this.commonProcessing()//再生ボタン押下時共通処理
        this.p3_audition_flg = 1;
        const dropzone3 = document.getElementById("dropzone3");
        dropzone3.style.zIndex = 60;
        this.audio3 = new Audio();
        this.audio3.src = this.music3;
        this.audio3.play();
        this.isPlay3 = true;
        let self = this;
        this.audio3.addEventListener(
          "ended",
          function () {
            self.isPlay3 = false;
            dropzone3.style.zIndex = 0;
          },
          false
        );
      }
    },
    //第四再生ボタン押下時処理
    playMusic4() {
      if (this.isActive4 !== null) {
        this.commonProcessing()//再生ボタン押下時共通処理
        this.p4_audition_flg = 1;
        const dropzone4 = document.getElementById("dropzone4");
        dropzone4.style.zIndex = 60;
        this.audio4 = new Audio();
        this.audio4.src = this.music4;
        this.audio4.play();
        this.isPlay4 = true;
        let self = this;
        this.audio4.addEventListener(
          "ended",
          function () {
            self.isPlay4 = false;
            dropzone4.style.zIndex = 0;
          },
          false
        );
      }
    },
    //第一停止ボタン押下時処理
    stopMusic1() {
      this.audio1.pause();
      this.audio1.currentTime = 0;
      this.isPlay1 = false;
      this.isPlayList = false;
      if (this.parentvariable1 !== true) {
        const dropzone1 = document.getElementById("dropzone1");
        dropzone1.style.zIndex = 0;
      }
      this.stop_flg = 1;
    },
    //第二停止ボタン押下時処理
    stopMusic2() {
      this.audio2.pause();
      this.audio2.currentTime = 0;
      this.isPlay2 = false;
      this.isPlayList = false;
      if (this.parentvariable2 !== true) {
        const dropzone2 = document.getElementById("dropzone2");
        dropzone2.style.zIndex = 0;
      }
      this.stop_flg = 1;
    },
    //第三停止ボタン押下時処理
    stopMusic3() {
      this.audio3.pause();
      this.audio3.currentTime = 0;
      this.isPlay3 = false;
      this.isPlayList = false;
      if (this.parentvariable3 !== true) {
        const dropzone3 = document.getElementById("dropzone3");
        dropzone3.style.zIndex = 0;
      }
      this.stop_flg = 1;
    },
    //第四停止ボタン押下時処理
    stopMusic4() {
      this.audio4.pause();
      this.audio4.currentTime = 0;
      this.isPlay4 = false;
      this.isPlayList = false;
      if (this.parentvariable4 !== true) {
        const dropzone4 = document.getElementById("dropzone4");
        dropzone4.style.zIndex = 0;
      }
      this.stop_flg = 1;
    },
    // 連続再生ボタン押下時処理
    musicPlayList() {
      if(this.isActive1 !== null || this.isActive2 !== null || this.isActive3 !== null || this.isActive4 !== null){
      if (this.$store.state.selectedSong === 1){
        this.timer1 = 7.35
        this.timer2 = 7.35
        this.timer3 = 7.35
      } else if(this.$store.state.selectedSong === 2) {
        this.timer1 = 6.32
        this.timer2 = 6.53
        this.timer3 = 6.53
      } else {
        console.log('selected song underfind')
      }
      this.allStopMusic();
      this.isPlayList = true;
      this.setActTime();
      this.play_button_flg = 1;

      this.audio1 = new Audio();
      this.audio2 = new Audio();
      this.audio3 = new Audio();
      this.audio4 = new Audio();

      if (this.isActive1 !== null) {
        this.audio1.src = this.music1;
        this.audio1.play();
        this.isPlay1 = true;
        this.p1_audition_flg = 1;
      } else {
        this.audio1.src = this.itemList[0].sound;
        this.audio1.muted = true;
        this.audio1.play();
        this.isPlay1 = true;
      }
      let self = this;
      this.audio1.addEventListener(
        "timeupdate",
        function f(e) {
          if (self.audio1.currentTime >= self.timer1) {
            self.isPlay1 = false;
            dropzone1.style.zIndex = 0;
            if (self.isActive2 !== null) {
              self.audio2.src = self.music2;
              self.isPlay2 = true;
              self.audio2.play();
              self.p2_audition_flg = 1;
              self.audio1.removeEventListener("timeupdate", f, false);
            } else {
              self.audio2.src = self.itemList[0].sound;
              self.isPlay2 = true;
              self.audio2.muted = true;
              self.audio2.play();
              self.audio1.removeEventListener("timeupdate", f, false);
            }
          }
        },
        false
      );
      this.audio2.addEventListener(
        "timeupdate",
        function f(e) {
          if (self.audio2.currentTime >= self.timer2) {
            self.isPlay2 = false;
            dropzone2.style.zIndex = 0;
            if (self.isActive3 !== null) {
              self.audio3.src = self.music3;
              self.isPlay3 = true;
              self.audio3.play();
              self.p3_audition_flg = 1;
              self.audio2.removeEventListener("timeupdate", f, false);
            } else {
              self.audio3.src = self.itemList[0].sound;
              self.isPlay3 = true;
              self.audio3.muted = true;
              self.audio3.play();
              self.audio2.removeEventListener("timeupdate", f, false);
            }
          }
        },
        false
      );
      this.audio3.addEventListener(
        "timeupdate",
        function f(e) {
          if (self.audio3.currentTime >= self.timer3) {
            self.isPlay3 = false;
            dropzone3.style.zIndex = 0;
            if (self.isActive4 !== null) {
              self.audio4.src = self.music4;
              self.isPlay4 = true;
              self.audio4.play();
              self.p4_audition_flg = 1;
              self.audio3.removeEventListener("timeupdate", f, false);
            } else {
              self.audio4.src = self.itemList[0].sound;
              self.isPlay4 = true;
              self.audio4.muted = true;
              self.audio4.play();
              self.audio3.removeEventListener("timeupdate", f, false);
            }
          }
        },
        false
      );
      this.audio4.addEventListener(
        "ended",
        function () {
          self.isPlay4 = false;
          dropzone4.style.zIndex = 0;
        },
        false
      );
      }
    },
    allStopMusic() {
      if (this.isPlay1) this.stopMusic1();
      if (this.isPlay2) this.stopMusic2();
      if (this.isPlay3) this.stopMusic3();
      if (this.isPlay4) this.stopMusic4();
    },
    async sendPostDetails() {
      const new_axios = this.axios.create({
        headers: {
          Authorization:
            "Bearer " + this.$cookies.get('token'),
          "Ocp-Apim-Subscription-Key": process.env.SUBSCRIPTION_KEY,
        },
        responseType: "json",
      });
      const body = {
        play_id: this.$store.state.playId,
        act_number: this.act_number,
        act_time: this.second + "." + this.milisecond,
        p1_block_number: this.p1_block_number,
        p2_block_number: this.p2_block_number,
        p3_block_number: this.p3_block_number,
        p4_block_number: this.p4_block_number,
        p1_audition_flg: this.p1_audition_flg,
        p2_audition_flg: this.p2_audition_flg,
        p3_audition_flg: this.p3_audition_flg,
        p4_audition_flg: this.p4_audition_flg,
        play_button_flg: this.play_button_flg,
        stop_flg: this.stop_flg,
      };
      const endpoint = process.env.API_ENDPOINT + "/details";
      const response = await new_axios
        .post(endpoint, body)
        .then((response) => {
          if (this.$store.state.isPittan === true) {
            this.$refs.child.updatePlaysApi();
            this.$store.commit("SET_ISPITTAN", false);
          }
        })
        .catch(function (error) {
          console.log("エラーだよ", error);
        });
    },
    setStartTime(time) {
      //performance.now()自体は前回のページから今回のページへと、遷移を開始した瞬間からの経過時間を算出する
      this.startTime = performance.now() - time;
    },
    start() {
      if (this.flag) {
        return false;
      }
      const vm_data = this;
      this.flag = true; // スタートしたらタイマーflagをtrueに
      this.setStartTime(vm_data.diffTime);
      (function progress() {
        vm_data.endTime = performance.now();
        vm_data.diffTime = vm_data.endTime - vm_data.startTime;
        [vm_data.second, vm_data.milisecond] = [
          Math.floor(vm_data.diffTime / 1000),
          Math.floor(vm_data.diffTime % 1000),
        ];
        vm_data.animationId = window.requestAnimationFrame(progress);
      })();
    },
    stop() {
      this.flag = false; // ストップしたらタイマーflagをfalseに
      window.cancelAnimationFrame(this.animationId);
    },
    reset() {
      if (this.flag) {
        return false;
      }
      this.startTime = this.diffTime = 0;
      this.p1_audition_flg = 0;
      this.p2_audition_flg = 0;
      this.p3_audition_flg = 0;
      this.p4_audition_flg = 0;
      this.play_button_flg = 0;
      this.stop_flg = 0;
    },
    setActTime() {
      if (this.$store.state.firstPittan !== true) {
        if (this.playCount === 0) {
          this.playCount += 1;
          this.start();
        } else {
          this.stop();
          this.act_number += 1;
          this.sendPostDetails();
          this.reset();
          this.start();
        }
      }
    },
    commonProcessing() {
      this.isPlayList = false;
      this.setActTime();
      this.allStopMusic();
    }
  },
};
</script>

 <style>
.main {
  clear: both;
}
body.play {
  background-image: url("~@/assets/img/アセット 66@3x.png");
  background-size: cover;
  background-repeat: no-repeat;
  position: relative;
}
.items {
  width: 50%;
  margin: auto;
}

.items li {
  list-style: none;
  background-image: url("~@/assets/img/アセット 62@3x.png");
  background-size: 100% auto;
  background-repeat: no-repeat;
  color: white;
  width: 85px;
  height: 85px;
  z-index: 50;
  border-radius: 50%;
  display: inline-block;
}
li:hover {
  cursor: pointer;
}
.targetitem li {
  list-style: none;
  background-image: url("~@/assets/img/アセット 62@3x.png");
  background-size: 100% auto;
  color: white;
  width: 90px;
  height: 90px;
  border-radius: 50%;
  margin: 20px;
  display: inline-block;
}
.play-back {
  position: absolute;
  top: 520px;
  left: 50px;
}
.play-back img {
  width: 135px;
}
.play-btns {
  position: absolute;
  top: 565px;
  left: 200px;
}
.play-btn {
  list-style: none;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
}
.play-btn1 {
  margin: 0 10px 0 10px;
}
.play-btn2 {
  margin: 0 10px 0 65px;
}
.play-btn3 {
  margin: 0 10px 0 65px;
}
.play-btn4 {
  margin: 0 10px 0 70px;
}
.play-btn img {
  width: 70px;
}
.item-0 {
  position: absolute;
  top: 80px;
  left: 200px;
}
.item-1 {
  position: absolute;
  top: 80px;
  left: 350px;
}
.item-2 {
  position: absolute;
  top: 80px;
  left: 500px;
}
.item-3 {
  position: absolute;
  top: 80px;
  left: 650px;
}
.item-4 {
  position: absolute;
  top: 200px;
  left: 275px;
}
.item-5 {
  position: absolute;
  top: 200px;
  left: 425px;
}
.item-6 {
  position: absolute;
  top: 200px;
  left: 575px;
}
.item-7 {
  position: absolute;
  top: 200px;
  left: 725px;
}
#dropzone1 {
  width: 100px;
  height: 100px;
  bottom: 135px;
  left: 240px;
  position: fixed;
}
#dropzone2 {
  width: 100px;
  height: 100px;
  bottom: 135px;
  left: 389px;
  position: fixed;
}
#dropzone3 {
  width: 100px;
  height: 100px;
  bottom: 135px;
  left: 535px;
  position: fixed;
}
#dropzone4 {
  width: 100px;
  height: 100px;
  bottom: 135px;
  left: 683px;
  position: fixed;
}
.growing-button1 {
  width: 85px;
  position: absolute;
  top: 484px;
  left: 241px;
  z-index: 61;
}
.growing-button2 {
  width: 85px;
  position: absolute;
  left: 389px;
  top: 484px;
  z-index: 61;
}
.growing-button3 {
  width: 85px;
  position: absolute;
  left: 535px;
  top: 484px;
  z-index: 61;
}
.growing-button4 {
  width: 85px;
  position: absolute;
  left: 681px;
  top: 484px;
  z-index: 61;
}
</style>



// WEBPACK FOOTER //
// src/pages/Gameplay.vue